import { CompanyAPI } from '@api';

const removeDriverPermission = (driverId) => CompanyAPI.removeDriverPermission({ driverId })
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { removeDriverPermission };
